import React from 'react'
import { requireAuth } from '../wrappers/requireAuth'
import { useUser } from "../hooks/useUser"
import { useNavigate } from 'react-router'
import { ProfileForm } from '../components/forms/profileForm'
import { useLoadProfileFromServer } from '../hooks/useLoadProfileFromServer'
import { useAppSelector } from '../hooks/reduxToolkit'
import { useUpdateProfile } from '../hooks/useUpdateProfile'
import { useSession } from '../providers/supabase'
import { AliceContactSettings, useAliceContactSettings } from '../components/forms/aliceContactSettings'

function EditProfile() {
  const user = useUser()
  if (!user) { throw new Error(`Not signed in!`) }

  const profile = useAppSelector((s) => s.membership?.profile || {})
  const session = useSession()
  const signInEmail = session?.user?.email ?? ''

  useLoadProfileFromServer()

  const [{error}, updateProfile] = useUpdateProfile()
  const contactSettings = useAliceContactSettings()

  const navigate = useNavigate()

  return <div className='row'>
    <div className='col-12'>
      <h1>Edit your profile</h1>

      <ProfileForm initial={profile} signInEmail={signInEmail}
        canSubmit={contactSettings.isValid}
        onSubmit={async (profile) => {
          await updateProfile(profile)
          await contactSettings.save()

          navigate('/')
        }}>
        <AliceContactSettings {...contactSettings} />
      </ProfileForm>

      {error && <div className='alert alert-danger' role='alert'>
        {error.message}
      </div>}
    </div>
  </div>
}

export default requireAuth(EditProfile)
